import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';

import settings from '../settings';

const initialPalette = {
  primary: settings.theme.primaryColor,
  secondary: settings.theme.secondaryColor,
  background: settings.theme.backgroundColor,
};

let theme = createMuiTheme({
  palette: initialPalette,
  typography: {
    h1: {
      fontSize: '3rem',
      color: grey[900],
      fontWeight: 800,
      letterSpacing: '-0.025em',
    },
    h2: {
      fontSize: '2.25rem',
      color: grey[900],
      fontWeight: 800,
      letterSpacing: '-0.025em',
    },
    h4: {
      fontSize: '1.125rem',
      textTransform: 'uppercase',
      fontWeight: 600,
      letterSpacing: '0.05em',
    },
    body2: {
      fontSize: '1.25rem',
      maxWidth: '48rem',
      color: grey[500],
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: '1.25rem',
    },
  }
});

theme = responsiveFontSizes(theme);

export default theme;
